import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../services/system/storage.service';
import { BoardTheme } from '../../../models/inModels/BoardTheme';
import { BoardThemeService } from '../../../services/board-themes/board-themes.service';

@Component({
  selector: 'app-edit-board-theme',
  templateUrl: './edit-board-theme.component.html'
})

export class EditBoardThemeComponent  {
	model: BoardTheme;
	loading = false;
	error: Message[];
	messages: Message[];
	id;
	constructor(
		public storageService: StorageService,
		private router: Router,
		private route: ActivatedRoute,
		private service: BoardThemeService,) {
		this.model = new BoardTheme();
	}

	ngOnInit() {
		this.loading = true;
		this.id = this.route.snapshot.params.Id;
		this.service.get(this.id).then(
			theme => {
				this.model = new BoardTheme(theme);
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	goBack(): void {
		this.router.navigate(['/board-themes']);
	}

	save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				console.log("Theme edited", result);
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	handleBackgroundImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.backgroundImageId = result.PublicId;
		this.loading = false;
	}

	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/board-themes/edit-board-theme/edit-board-theme.component.ts